import { FC } from 'react';
import { getQueryKey } from '@trpc/react-query';
import useHandleTrpcMutation from 'hooks/ui/useHandleTrpcMutation';
import api from 'lib/trpcClient';
import { Realm } from 'further-types/global';
import NoDataRoom from './NoDataRoom';
import DataRoomEdit from './DataRoomEdit';
import { useHasPermissions } from 'hooks/ui/usePermissions';
import { RolePermission } from 'further-types/admin-user-role';

type Props = {
  linkedToId: string;
  dataRoomId?: string;
  setLiveDisabled?: boolean;
};

const DataRoom: FC<Props> = ({ linkedToId, setLiveDisabled, ...props }) => {
  const {
    data,
    mutate: addDataRoom,
    isPending,
  } = api.dataRoom.create.useMutation(
    useHandleTrpcMutation()({
      invalidations: [getQueryKey(api.fund.get)],
    }),
  );

  const [canCreate] = useHasPermissions([RolePermission.CreateDataRoom]);

  const handleAddDataRoom = () => {
    if (!canCreate) return;
    addDataRoom({ realm: Realm.Eis, linkedToId });
  };

  const dataRoomId = props.dataRoomId ?? data?.id;

  return dataRoomId ? (
    <DataRoomEdit setLiveDisabled={setLiveDisabled} dataRoomId={dataRoomId} />
  ) : (
    <NoDataRoom
      creating={isPending}
      onAddDataRoom={handleAddDataRoom}
      canCreate={canCreate}
    />
  );
};

export default DataRoom;
